import { api } from '@/helpers/apiClient'
import { logRequestFailure } from '@/helpers/request-outcome'

import {
  furnitureGroupDtoSchema,
  furnitureGroupListDtoSchema,
  type FurnitureGroupDto,
  type FurnitureGroupListDto,
} from '@lib/dto/furniture-group.dto'
import type { CreateFurnitureGroupInput, UpdateFurnitureGroupInput } from '@lib/input/furniture-group.input'

/** Service for the furniture-group endpoints (reusable arrangements of catalog items). */
class FurnitureGroupService {
  async list(venueId?: string | null): Promise<FurnitureGroupListDto> {
    try {
      const query = venueId ? `?venueId=${encodeURIComponent(venueId)}` : ''
      return await api.get(`/furniture-groups${query}`, furnitureGroupListDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to list furniture groups', {}, error)
      throw error
    }
  }

  async create(input: CreateFurnitureGroupInput): Promise<FurnitureGroupDto> {
    try {
      return await api.post('/furniture-groups', input, furnitureGroupDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to create furniture group', {}, error)
      throw error
    }
  }

  async update(id: string, input: UpdateFurnitureGroupInput): Promise<FurnitureGroupDto> {
    try {
      return await api.patch(`/furniture-groups/${id}`, input, furnitureGroupDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to update furniture group', { id }, error)
      throw error
    }
  }
}

export const furnitureGroupService = new FurnitureGroupService()
